import { render, staticRenderFns } from "./ReportOverview.vue?vue&type=template&id=56310a44&"
import script from "./ReportOverview.vue?vue&type=script&lang=js&"
export * from "./ReportOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports